import { RoundShareIconButton } from 'src/app/shared/components/RoundShareIconButton';

import { useShareLinks } from './hooks/useShareLinks';

export function ShareLinks() {
	const {
		data: { buttonConfigs },
	} = useShareLinks();

	return (
		<div className="grid w-full grid-cols-[repeat(auto-fill,minmax(4.5rem,1fr))] items-center justify-items-center gap-x-2 gap-y-1 lg:gap-x-4">
			{buttonConfigs.map(({ channel, action, label, labelReplacements, successLabel }) => (
				<RoundShareIconButton
					key={`update-share-${channel}`}
					action={action}
					channel={channel}
					label={label}
					labelReplacements={labelReplacements}
					successLabel={successLabel}
					data-qa={`update-share-${channel}`}
					data-testid={`update-share-${channel}`}
					className="min-w-[4.5rem]"
				/>
			))}
		</div>
	);
}
